// extracted by mini-css-extract-plugin
export default {"privacyScreen":"PrivacyScreen_privacyScreen__n+iQZ"};